import { db } from "./firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export const getNextInvoiceNumber = async () => {
  const ref = doc(db, "Invoice_Counters", "invoice");
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    await setDoc(ref, { currentNumber: 1 });
    return "INV-0001";
  }

  const next = snap.data().currentNumber + 1;
  await updateDoc(ref, { currentNumber: next });

  return `INV-${String(next).padStart(4, "0")}`;
};